import { ReactElement } from 'react'
import BaseLayout from 'src/v3/components/base-layout'
import { AnalyticsIcon } from '../core/icons'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => (
  <BaseLayout
    children={children}
    domain="scribe"
    subMenuItems={[
      {
        name: 'User Demographics',
        route: '/',
        allowInLimited: false,
        icon: <AnalyticsIcon />,
      },
      {
        name: 'Sentiment Analysis',
        route: '/sentiment-analysis',
        allowInLimited: false,
        icon: <AnalyticsIcon />,
      },
      {
        name: 'CAPCE Submission Analytics',
        route: '/capce-submission-report',
        allowInLimited: false,
        icon: <AnalyticsIcon />,
      },
      {
        name: 'Auth Login Analytics',
        route: '/auth-login-report',
        allowInLimited: false,
        icon: <AnalyticsIcon />,
      },
    ]}
  />
)
